import { render, staticRenderFns } from "./cod.vue?vue&type=template&id=aa6b4e9a&scoped=true&"
import script from "./cod.vue?vue&type=script&lang=js&"
export * from "./cod.vue?vue&type=script&lang=js&"
import style0 from "./cod.vue?vue&type=style&index=0&id=aa6b4e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b4e9a",
  null
  
)

export default component.exports